// extracted by mini-css-extract-plugin
export default {"blurdata":"layout_blurdata__cOHHC","page":"layout_page__FTVMN","pageBody":"layout_pageBody__kPxu9","headerContainer":"layout_headerContainer__6dg6P"};